import React, { createContext, useState, useMemo, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export default function ThemeContextProvider({ children }) {
  const [mode, setMode] = useState("light");

  useEffect(() => {
    const storedMode = localStorage.getItem("themeMode");
    if (storedMode) setMode(storedMode);
  }, []);

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const newMode = prevMode === "light" ? "dark" : "light";
          localStorage.setItem("themeMode", newMode);
          return newMode;
        });
      },
    }),
    []
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: { main: mode === "light" ? "#1976d2" : "#90caf9" },
          secondary: { main: mode === "light" ? "#9c27b0" : "#f48fb1" },
          background: {
            default: mode === "light" ? "#f4f6f8" : "#121212",
            paper: mode === "light" ? "#ffffff" : "#1e1e1e",
          },
          text: {
            primary: mode === "light" ? "#1a1a1a" : "#e0e0e0",
            secondary: mode === "light" ? "#4d4d4d" : "#b0b0b0",
            disabled: "#888888",
          },
          divider: mode === "light" ? "#e0e0e0" : "#333333",
        },
        
components: {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        color: (theme) => theme.palette.text.primary,
        fontWeight: 600,
      },
      body: {
        color: (theme) => theme.palette.text.primary,
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: (theme) => theme.palette.text.secondary,
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: {
        borderColor: mode === "light" ? "#ccc" : "#555",
      },
    },
  },
},

      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
}